import { JQLLexer } from '@atlaskit/jql-parser';
import { errorMessages } from '../messages';

/**
 * Show the appropriate error message when parsing JQL fails and a function argument rule was expected.
 */
export var handleFunctionArgumentRuleError = function handleFunctionArgumentRuleError(currentToken, intl) {
  var isEOF = currentToken.type === JQLLexer.EOF;
  return isEOF ? intl.formatMessage(errorMessages.expectingFunctionArgBeforeEOF) : intl.formatMessage(errorMessages.expectingFunctionArgButReceived, {
    received: currentToken.text
  });
};